import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { map, share } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class ApiGraficosService {
    private apiUrl = environment.apiUrl;
    private data;
    private data_observer;
    private id_projeto;
    public cores = {
        Feminino: '#BE3075',
        Masculino: '#009EE0',

        'Bolsista não UFAL': '#BE3075',
        'Bolsista UFAL': '#EB001F',
        CLT: '#64A12D',
        'Jovem aprendiz': '#008AC5',
        'Servidor UFAL': '#FFED00',
        'Servidor não UFAL': '#000000',

        Doutorado: '#EB001F',
        Especialização: '#008AC5',
        Graduação: '#fb8c00',
        Médio: '#76ff03',
        Mestrado: '#1b5e20',
        'Pós-doutorado  ': '#BE3075',
        Técnico: '#000000',
    };

    constructor(private http: HttpClient) {}

    changeProject(id_projeto) {
        this.id_projeto = id_projeto;
        this.data = null;
        this.data_observer = null;
    }

    getGraficos() {
        if (this.data) {
            return of(this.data);
        } else if (this.id_projeto) {
            if (!this.data_observer) {
                this.data_observer = this.http
                    .get(
                        `${this.apiUrl}colaboradores/graficos/${this.id_projeto}/`
                    )
                    .pipe(
                        map(res => {
                            this.data = this.parseResults(res);
                            return this.data;
                        }),
                        share()
                    );
            }

            return this.data_observer;
        } else {
            return of([]);
        }
    }

    parseResults(data) {
        const res = [];

        res.push(
            data['Colaboradores ativos por sexo'].map(el => {
                if (el.sexo === 'M') {
                    el.sexo = 'Masculino';
                } else if (el.sexo === 'F') {
                    el.sexo = 'Feminino';
                }

                return {
                    sexo: el.sexo,
                    total: el.valor_total,
                };
            })
        );

        let categories = [
            '18-23',
            '24-29',
            '30-35',
            '36-41',
            '42-47',
            '48-53',
            '54-59',
        ].map(el => parseInt(el.split('-')[1]));
        let current_index = 0;

        res.push(
            data['Colaboradores por faixa etária e sexo'].reduce(
                (acc, cur) => {
                    while (categories[current_index] < cur.Idade) {
                        if (categories.length < current_index) {
                            current_index = categories.length - 1;
                            break;
                        }
                        current_index++;
                    }

                    acc[0].data[current_index] -= cur.Masculino;
                    acc[1].data[current_index] += cur.Feminino;

                    return acc;
                },
                [
                    {
                        name: 'Masculino',
                        data: Array(categories.length).fill(0),
                    },
                    {
                        name: 'Feminino',
                        data: Array(categories.length).fill(0),
                    },
                ]
            )
        );
        res.push(data['Colaboradores por vínculo']);

        res.push(
            data['Colaboradores por maior formação e sexo'].map(el => {
                return {
                    formacao: el.maior_formacao,
                    total: el.total,
                };
            })
        );

        const maior_formacao_e_sexo = data[
            'Colaboradores por maior formação e sexo'
        ].reduce(
            (acc, cur) => {
                acc.series[0].data.push(cur.F);
                acc.series[1].data.push(cur.M);
                acc.xAxis.categories.push(cur.maior_formacao);

                return acc;
            },
            {
                series: [
                    {
                        name: 'Feminino',
                        data: [],
                    },
                    {
                        name: 'Masculino',
                        data: [],
                    },
                ],
                xAxis: {
                    categories: [],
                },
            }
        );
        res.push(maior_formacao_e_sexo);

        res.push(
            data['Colaboradores por maior formação e vínculo'].reduce(
                (acc, cur) => {
                    acc.xAxis.categories.push(cur['Formação']);
                    acc.series.forEach(element => {
                        element.data.push(cur[element.name]);
                    });

                    return acc;
                },
                {
                    series: Object.keys(
                        data['Colaboradores por maior formação e vínculo'][0]
                    )
                        .slice(1, -1)
                        .map(el => ({ name: el, data: [] })),
                    xAxis: {
                        categories: [],
                    },
                }
            )
        );
        res.push(
            data['Colaboradores por vínculo e maior formação'].reduce(
                (acc, cur) => {
                    acc.xAxis.categories.push(cur['Vinculo']);
                    acc.series.forEach(element => {
                        element.data.push(cur[element.name]);
                    });

                    return acc;
                },
                {
                    series: Object.keys(
                        data['Colaboradores por vínculo e maior formação'][0]
                    )
                        .slice(1, -1)
                        .map(el => ({ name: el, data: [] })),
                    xAxis: {
                        categories: [],
                    },
                }
            )
        );

        res.push(
            data['colaboradores por carga horária'].map(el => ({
                name: `${el.chs}`,
                y: parseInt(el.total),
            }))
        );

        return res;
    }
}
